import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type { APIResponse, ContactMatterSummary } from "@/lib/types";
import { completeOwnedConnections } from "@/lib/data/requests/connections/owned-connections";

export const retrieveContactMattersV1 = async (contactId?: string) => {
  const path = `matters/v4/contacts/${contactId}`;
  const response = await authenticatedFastApiAxiosInstance.get<
    APIResponse<ContactMatterSummary[]>
  >(path, {
    params: { history: false, connectionLimit: 25 },
  });
  const data = [];
  for (const summary of response.data.data) {
    const complete = await completeOwnedConnections(summary, path, summary.id);
    // The owner endpoint pages every Contact; expose only this Contact's roles
    // after completing those pages, including assignments on a later page.
    data.push({
      ...complete,
      connections: complete.connections.filter(
        (connection) =>
          connection.targetObjectType === "contact" &&
          connection.targetObjectId === contactId,
      ),
    });
  }
  return { ...response.data, data };
};

export type MatterConflictCheckInput = {
  contactId: string;
  label: "Client" | "Defendant";
  matterId?: string;
};

export const checkMatterContactConflict = (data: MatterConflictCheckInput) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<{ hasConflictOfInterest: boolean }>
    >(`${baseFastApiMatterRoute}/contacts/conflict-check`, data)
    .then((res) => res.data);
